import axios from "axios";

const logout = () => {
  localStorage.clear();
  window.location.replace("/");
  localStorage.removeItem("activeSession");
};

//* ADMIN
export const serverApi = axios.create({
  baseURL: `${process.env.REACT_APP_SERVER_URL}/`,
  timeout: 90000,
  headers: {
    "Content-Type": "application/json",
  },
});

serverApi.interceptors.response.use(
  (response) => {
    if (response.status === 401) {
      logout();
    }
    return response;
  },
  (error) => {
    if (error.response === undefined) {
      logout();
    }
    // return Promise.reject(error);
    console.log(`Server unreachable`, error);
    return new Error(`Server unreachable ${error?.message}`);
  }
);

//* NOTIFICATIONS
export const notificationServiceApi = axios.create({
  baseURL: `${process.env.REACT_APP_NOTIFICATION_URL}/`,
  timeout: 90000,
  headers: {
    "Content-type": "application/json",
  },
});

notificationServiceApi.interceptors.response.use(
  (response) => {
    if (response.status === 401) {
      logout();
      return response;
    } else {
      return response;
    }
  },
  (error) => {
    // if (error.response.status === 403) {
    if (error.response === undefined) {
      // store.dispatch(signOut());
      // return response;
    }
    // return Promise.reject(error);
    return new Error(`Server unreachable :: ${JSON.stringify(error)}`);
  }
);
